import { render, staticRenderFns } from "./FilteredCosts.vue?vue&type=template&id=48ce5741&"
import script from "./FilteredCosts.vue?vue&type=script&lang=js&"
export * from "./FilteredCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports